import { DollarSign, Users, Wrench, Globe, MapPin } from "lucide-react";

const tranches = [
  { amount: "First $500K", cap: "$8M cap", highlight: true },
  { amount: "Remaining", cap: "$10M cap", highlight: false },
];

const uses = [
  { icon: Users, label: "Sales & customer acquisition", pct: 35 },
  { icon: Wrench, label: "Product refinement & edge cases", pct: 30 },
  { icon: Globe, label: "Operational support & rollout", pct: 20 },
  { icon: MapPin, label: "Expansion beyond New York", pct: 15 },
];

export default function FundraisingSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-fundraising-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        THE ASK
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        Raising $1M to scale rollout and expansion
      </h1>

      <div className="flex-1 flex flex-col md:flex-row gap-4 md:gap-6 sm:gap-8 min-h-0">
        <div className="flex-1 flex flex-col">
          <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-3 font-body">
            SAFE Structure
          </div>
          <div className="flex flex-col gap-2 sm:gap-3 flex-1 justify-center">
            {tranches.map((t, i) => (
              <div
                key={i}
                className={`rounded-lg p-3 sm:p-4 border flex items-center justify-between ${
                  t.highlight
                    ? "bg-blue-50 border-blue-200"
                    : "bg-slate-50 border-slate-200"
                }`}
              >
                <div>
                  <div
                    className={`text-sm sm:text-base font-bold font-heading ${
                      t.highlight ? "text-blue-600" : "text-slate-700"
                    }`}
                  >
                    {t.amount}
                  </div>
                </div>
                <div
                  className={`text-sm font-mono font-medium ${
                    t.highlight ? "text-blue-600" : "text-slate-500"
                  }`}
                >
                  {t.cap}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-3 flex items-center gap-2">
            <DollarSign className="h-3.5 w-3.5 text-blue-600" />
            <span className="text-sm text-slate-500 font-body">
              Instrument: SAFE (Simple Agreement for Future Equity)
            </span>
          </div>
        </div>

        <div className="flex-1 flex flex-col">
          <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-3 font-body">
            Use of Funds
          </div>
          <div className="flex flex-col gap-2 sm:gap-3 flex-1 justify-center">
            {uses.map((u, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-7 h-7 bg-blue-50 rounded flex items-center justify-center shrink-0">
                  <u.icon className="h-3.5 w-3.5 text-blue-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-medium text-slate-700 font-body">
                      {u.label}
                    </span>
                    <span className="text-sm font-bold text-slate-900 font-mono">
                      {u.pct}%
                    </span>
                  </div>
                  <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-blue-600 rounded-full"
                      style={{ width: `${u.pct}%` }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
